import { render } from "./RecoveredOrders.vue?vue&type=template&id=551746f6&scoped=true"
import script from "./RecoveredOrders.vue?vue&type=script&lang=js"
export * from "./RecoveredOrders.vue?vue&type=script&lang=js"

import "./RecoveredOrders.vue?vue&type=style&index=0&id=551746f6&lang=scss&scoped=true"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-551746f6"]])

export default __exports__